import { ACTIONS } from "UTILS/Constants";

const initialState = {
  logoUrl: null,
  customerData:{},
  currentActiveTab:"1",
  sessionKey: null,
  Organization:null,
  sessionsCapacity: {
    systemMaxCapacity: 0,
    usedCapacity: 0
  },
  cobrowseSettings: {
    cobrowseType: "",
    allowCustomUrl: false,
    customUrlLabels: [], 
    targetSites: [],
  },
  operatorSkills: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SET_ADMIN_LOGO_URL:
      return {
        ...state,
        logoUrl: action.logoUrl
      };
    case ACTIONS.SET_CUSTOMER_DATA:
      return {
        ...state,
        customerData: action.customerData
      };
    case ACTIONS.ORGANISATION_ACTION.SET_ACTIVE_TAB:
      return{
        ...state,
        currentActiveTab:action.value
      };
    case ACTIONS.ORGANISATION_ACTION.SET_ORGANIZATION_DATA:
      return{
        ...state,
        Organization:action.organization
      };
    case ACTIONS.SET_SESSIONS_CAPACITY:
      return{
        ...state,
        sessionsCapacity:action.sessionsCapacity
      };
    case ACTIONS.CO_BROWSE.SET_CO_BROWSE_DETAILS:
      return{
        ...state,
        cobrowseSettings: action.cobrowseSettings
      };
    case ACTIONS.SUPPORT_CENTER.SET_SKILL_LIST:
      return{
        ...state,
        operatorSkills: action.operatorSkills
      };
    default:
      return state;
  }}